import React from 'react';
import { ParticipantViewModel } from 'stageclip-common';

import { makeGuardedModal } from 'components/guardedModal/makeGuardedModal';
import { ReviewModalContentContainer } from 'components/events/participants/reviewModal/ReviewModalContentContainer';
import { SimpleModalId } from 'constants/modalId';
import { InternalActionTypes } from 'constants/actionTypes';
import { RemoveVgQaParticipantAction } from 'actions/participantActions';

const onSuccessAction = (payload: ParticipantViewModel) =>
  ({
    type: InternalActionTypes.RemoveVgQaParticipant,
    payload: {
      participantId: payload.id,
    },
  } as RemoveVgQaParticipantAction);

const ReviewModal = makeGuardedModal(SimpleModalId.ParticipantReview, ReviewModalContentContainer);

export const QaQueueReviewModal = () => <ReviewModal onSuccessAction={onSuccessAction} />;
